export var PLATFORM = /*#__PURE__*/function (PLATFORM) {
  PLATFORM["NATIVE"] = "mobileNative";
  PLATFORM["HYBRID"] = "mobileHybrid";
  PLATFORM["WEB"] = "web";
  return PLATFORM;
}({});
export var MODE = /*#__PURE__*/function (MODE) {
  MODE["RENDERER"] = "renderer";
  MODE["EDITOR"] = "editor";
  return MODE;
}({});
export var RESOLVE_METHOD = /*#__PURE__*/function (RESOLVE_METHOD) {
  RESOLVE_METHOD["COMPONENT"] = "component";
  RESOLVE_METHOD["CONSUMER"] = "consumer";
  RESOLVE_METHOD["ORPHANED"] = "orphaned";
  return RESOLVE_METHOD;
}({});